/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { Component } from 'react';
import TwoSidedLayout from '../components/TwoSidedLayout'
import axios from 'axios';
import { AUTH_CONFIG } from '../Auth/auth0-variables';
import SignupForm from './Forms/SignupForm'
import Auth from './Auth';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { setAuthTokens } from './tokenManager';
import { isMobile } from "react-device-detect";

const transitionCss = css`
    .signup-transition {
        opacity: 1;
        transform: translateY(0);
        transition: opacity .35s ease, transform .35s ease;
    }

    .signup-transition.fade-out {
        opacity: 0;
        transform: translateY(12px);
        pointer-events: none;
    }
`;
class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            turnstileResponse: null,
            transitioning: false,
        };
        this.auth = new Auth(this.props.history);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        // Avoid loading Turnstile in local development (localhost/127.0.0.1)
        // Cloudflare Turnstile may reject requests from localhost unless the key is configured for it.
        const isLocalhost = (typeof window !== 'undefined') && (window.location && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'));
        const isDevEnv = process.env.NODE_ENV === 'development';
        if (isLocalhost || isDevEnv) {
            // Skip loading Turnstile when developing locally to prevent 400 errors (110200) from Cloudflare
            return;
        }

        // Load Turnstile script and render widget into hidden div
        if (!window.turnstile) {
            const s = document.createElement('script');
            s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
            s.async = true;
            s.defer = true;
            s.onload = () => this.renderTurnstile();
            document.body.appendChild(s);
        } else {
            this.renderTurnstile();
        }
    }

    renderTurnstile() {
        try {
            const siteKey = process.env.REACT_APP_TURNSTILE_SITEKEY || AUTH_CONFIG.TURNSTILE_SITEKEY;
            if (!siteKey) return;
            // create container for the widget if not present
            if (!this.turnstileContainer) {
                this.turnstileContainer = document.createElement('div');
                // Render off-screen instead of display:none so the widget can initialize
                this.turnstileContainer.style.position = 'absolute';
                this.turnstileContainer.style.left = '-9999px';
                this.turnstileContainer.style.top = '0';
                this.turnstileContainer.setAttribute('aria-hidden', 'true');
                document.body.appendChild(this.turnstileContainer);
            }
            // render widget and capture token via callback
            if (window.turnstile && this.turnstileContainer) {
                // eslint-disable-next-line no-undef
                // Store the returned widget id so we can execute programmatically if needed
                this.turnstileWidgetId = window.turnstile.render(this.turnstileContainer, {
                    sitekey: siteKey,
                    callback: (token) => {
                        this.setState({ turnstileResponse: token });
                    }
                });
            }
        } catch (e) {
            console.warn('Turnstile render failed', e);
        }
    }

    // Returns a Promise that resolves to a Turnstile token string or null on timeout
    getTurnstileToken(timeoutMs = 8000) {
        return new Promise((resolve) => {
            // If we already have a token, return it immediately
            if (this.state.turnstileResponse) {
                return resolve(this.state.turnstileResponse);
            }

            // If turnstile is available and we have a widget id, execute to request a token
            if (window.turnstile && this.turnstileWidgetId !== undefined) {
                try {
                    // Trigger the challenge / token generation
                    window.turnstile.execute(this.turnstileWidgetId);
                } catch (e) {
                    // execute may not be supported in some contexts
                    console.warn('Turnstile execute failed', e);
                }

                const pollInterval = 200;
                let waited = 0;
                const iv = setInterval(() => {
                    if (this.state.turnstileResponse) {
                        clearInterval(iv);
                        return resolve(this.state.turnstileResponse);
                    }
                    waited += pollInterval;
                    if (waited >= timeoutMs) {
                        clearInterval(iv);
                        return resolve(null);
                    }
                }, pollInterval);
                return;
            }

            // No widget available, resolve null
            resolve(null);
        });
    }

    handleSubmit = (email, firstName, lastName, password) => {
        var model = {
            Email: email,
            FirstName: firstName,
            LastName: lastName,
            Password: password
        }

        const attachTokenAndPost = async () => {
            let token = this.state.turnstileResponse;
            if (!token) {
                try {
                    token = await this.getTurnstileToken(6000);
                } catch (e) {
                    console.warn('Error while getting Turnstile token', e);
                }
            }

            if (token) {
                model.TurnstileToken = token;
            } else {
                // Optional developer bypass: if REACT_APP_TURNSTILE_OPTIONAL is truthy, proceed without token
                const optional = (process.env.REACT_APP_TURNSTILE_OPTIONAL || '').toString().toLowerCase();
                const allowWithout = optional === '1' || optional === 'true' || optional === 'yes';
                if (!allowWithout) {
                    // Attach a flag so server can choose to bypass stricter checks for known cases or provide helpful error
                    model.TurnstileTokenMissing = true;
                    console.warn('Turnstile token missing; sending request with TurnstileTokenMissing flag.');
                } else {
                    console.warn('Turnstile token missing but proceeding due to REACT_APP_TURNSTILE_OPTIONAL setting.');
                }
            }

            axios.post(AUTH_CONFIG.API_URL + "/api/auth/SignUpStart", model)
                .then((response) => {
                    setAuthTokens({
                        accessToken: response.data.token,
                        refreshToken: response.data.refreshToken,
                        expires: response.data.expires
                    });
                    localStorage.setItem('user_type', "1");
                    this.setState({ transitioning: true });
                    setTimeout(() => {
                        this.props.history.replace("/onboarding");
                    }, 360);
                })
                .catch((error) => {
                    this.setState({
                        showVisitNumberError: true,
                        errorMessage: 'We were unable to complete your signup. Please check your information and try again.'
                    });
                });
        };

        attachTokenAndPost();
    }

    render() {
        return (
            <TwoSidedLayout width={472}>
                <div className={`height100 flexcolumn width100 justifycenter signup-transition ${this.state.transitioning ? 'fade-out' : ''}`} css={transitionCss} style={{ maxWidth: '452px', margin: 'auto' }}>
                {this.state.errorMessage &&
                    <MessageBar messageBarType={MessageBarType.error} className="mb10" isMultiline={true}>{this.state.errorMessage}</MessageBar>
                }

               
                    <SignupForm callback={this.handleSubmit} />
                </div>
                <div style={{ padding: isMobile ? '24px 0px 40px 0px' : '24px 0px 10% 0px' }}>
                    <div className="flexcolumn aligncenter mt20">
                        <p className="d-p">By proceeding, you agree to the</p>
                        <div className="displayflex justifycenter">
                            <a id="" href="https://www.teamslyapp.com/terms" rel="noreferrer" target="_blank">
                                <span className="d-p">Terms of Service</span>
                            </a>
                            <div className="mx5"> and </div>
                            <a id="" href="https://www.teamslyapp.com/privacy-policy" rel="noreferrer" target="_blank" >
                                <span className="d-p">Privacy Policy</span>
                            </a>
                        </div>
                    </div>
                </div>
            </TwoSidedLayout>
        );
    }
}


export default Signup


